/** Above sticky nav (z-50) and hero side rail so currency menus are never clipped. */
export const CURRENCY_SELECTOR_OVERLAY_Z_CLASS = "z-[100]" as const;

export const DEFAULT_CURRENCY_SELECTOR_MODAL = {
  title: "Select a currency",
  subtitle:
    "Choose your preferred currency to view prices in your local format.",
};

export const DEFAULT_CURRENCY_SELECTOR_TOGGLE = {
  text: "View different currency",
};

export const DEFAULT_CURRENCY_SELECTOR_MODAL_CURRENCIES = [
  { code: "AUD", name: "Australian Dollar", symbol: "A$", flag: "🇦🇺" },
  { code: "BRL", name: "Brazilian Real", symbol: "R$", flag: "🇧🇷" },
  { code: "CAD", name: "Canadian Dollar", symbol: "C$", flag: "🇨🇦" },
  { code: "CHF", name: "Swiss Franc", symbol: "CHF", flag: "🇨🇭" },
  { code: "CNY", name: "Chinese Yuan", symbol: "¥", flag: "🇨🇳" },
  { code: "EUR", name: "Euro", symbol: "€", flag: "🇪🇺" },
  { code: "GBP", name: "British Pound", symbol: "£", flag: "🇬🇧" },
  { code: "INR", name: "Indian Rupee", symbol: "₹", flag: "🇮🇳" },
  { code: "JPY", name: "Japanese Yen", symbol: "¥", flag: "🇯🇵" },
  { code: "KRW", name: "South Korean Won", symbol: "₩", flag: "🇰🇷" },
  { code: "MXN", name: "Mexican Peso", symbol: "MX$", flag: "🇲🇽" },
  { code: "SGD", name: "Singapore Dollar", symbol: "S$", flag: "🇸🇬" },
  { code: "USD", name: "US Dollar", symbol: "$", flag: "🇺🇸" },
  { code: "ZAR", name: "South African Rand", symbol: "R", flag: "🇿🇦" },
];
